export class Gastos {
    idgasto?:number
    idliquida?:number
    concepto?:string
    total?:number
    fecha?:string
    hora?:string
    idvende?:string
    estado?:string
    idtipogasto?:number

    constructor(){}
}
